<template>
    <v-avatar color="grey darken-1" :size="size">
        <img v-if="imageUrl" :src="imageUrl" @error="imageUrlError" />
        <span v-else class="white--text" :style="'font-size:' + fontSize + 'px;'">
            {{ initials }}
        </span>
    </v-avatar>
</template>

<script>
import { AssetService } from "@services";
import { mapGetters, mapActions } from "vuex";

export default {
    name: "AccountUserAvatar",

    props: {
        user: {
            type: Object,
        },
        size: {
            type: Number,
            default: 32,
        },
    },

    data() {
        return {
            imageUrl: null,
        };
    },

    computed: {
        ...mapGetters("cache", ["getItemByKey"]),
        fontSize() {
            return Math.round(this.size / 2);
        },
        initials() {
            if (this.user?.initials == null) {
                return "?";
            }

            return this.user.initials;
        },
    },

    methods: {
        ...mapActions("cache", ["addFile"]),

        async getProfileImageFromS3() {
            try {
                const id = this.user.profileImageId ? this.user.profileImageId : this.user.profileImageAssetId;
                if (id) {
                    const r = await AssetService.downloadAssetUrl(id, true);
                    if (r?.data?.downloadUrl == null) return;
                    const d = await fetch(r.data.downloadUrl);
                    const imageBlob = await d.blob();
                    this.imageUrl = URL.createObjectURL(imageBlob);
                    this.addFile({ key: this.user.profileImageKey, value: imageBlob });
                }
            } catch (err) {
                //silent error
            }
        },
        imageUrlError() {
            this.imageUrl = null;
        },

        // Generating Image url
        updateProfileImage() {
            if (!this.user) return;

            const key = this.user.profileImageKey || this.user.profileImageAssetKey;
            if (key === "00000000-0000-0000-0000-000000000000") return;

            const s3Item = this.getItemByKey(key);
            if (s3Item) {
                this.imageUrl = s3Item.value;
            } else {
                this.getProfileImageFromS3();
            }
        },
    },
    // To update user profile images when page reloads

    mounted() {
        this.updateProfileImage();
    },
};
</script>
